import {
  getGameHistory,
  setGameHistory,
  setLastGame
} from 'utils/localStorage';

export function addToHistory(game, tournament) {
  if (!game || !game.id) {
    return;
  }
  if (!tournament) {
    const history = getGameHistory().filter(id => id !== game.id);
    history.unshift(game.id);
    setGameHistory(history);
  }
  setLastGame(game.name);
}

const HISTORY_LIMIT = 10;
export function orderGamesByHistory(games) {
  if (!games || !games.length) {
    return [];
  }
  const sortedGames = new Array(games.length);

  // Build a map of gameId => gameObj
  const gamesMap = {};
  games.forEach(game => (gamesMap[game.id] = game));

  // Trim disabled games
  const localHistory = getGameHistory();
  const history = localHistory.filter(id => id && gamesMap[id]);

  // Build a map of gameId => gameOrder
  const historyMap = {};
  history.forEach((id, index) => (historyMap[id] = index));

  // Sort the games based on history order, placing unknown (new) games up front
  const recentGameOffset = games.length - history.length;
  let newGameIndex = 0;
  let oldGameIndex = recentGameOffset + HISTORY_LIMIT;
  games.forEach(game => {
    let index = historyMap[game.id];
    if (index === undefined) {
      // Unknown (new) game, place at next front position
      index = newGameIndex++;
    } else if (index >= HISTORY_LIMIT) {
      // Old game, show in default order after recent games
      index = oldGameIndex++;
    } else {
      // Recent game, place at front, but offset to leave room for any new games in list
      index += recentGameOffset;
    }
    sortedGames[index] = game;
  });

  // Update history
  if (newGameIndex || localHistory.length !== history.length) {
    setGameHistory(sortedGames.map(game => game.id));
  }

  return sortedGames;
}
